import React from 'react';
import { currencyUtilities } from '@incentivegames/ig-frontend-common/lib/utilities/currencyUtilities';
import Config from 'theme/config';
import { dreamteamUtilities } from 'utilities/dreamteamUtilities';
import useIGTranslation from 'hooks/useIGTranslation';
import BonusWheelView, { IBonusWheelViewData, IWedgeObject } from './BonusWheelView';

export interface IBonusWheelProps {
  prizeMultiplier: number;
  prizeAmount: number; // Must exist in the prizeArray object.value
  onFinishedCallback: () => void;
  prizeCurrencyCode: string;
}

const BonusWheel = (props: IBonusWheelProps) => {
  const currency = currencyUtilities.getCurrencyByCode(props.prizeCurrencyCode);
  const { t } = useIGTranslation();

  const renderBonusText = () => {
    const formattedTotalPrize = dreamteamUtilities.formatCurrencyString(currency.symbol, props.prizeCurrencyCode, props.prizeMultiplier * props.prizeAmount);
    const formattedPrize = dreamteamUtilities.formatCurrencyString(currency.symbol, props.prizeCurrencyCode, props.prizeAmount);
    return (
      <span>
        {t('you-will-receive')} {props.prizeMultiplier > 1 && <span className="bonus-wheel__strike">{formattedPrize}</span>} <span className="bonus-wheel__amount">{formattedTotalPrize}</span>{' '}
        {t('for-each-goal')}
      </span>
    );
  };

  const prizeConfig = Config.bonusWheel.prizesConfig[props.prizeCurrencyCode];

  const data: IBonusWheelViewData = {
    prizePosition: prizeConfig.prizeArray.findIndex((prize: IWedgeObject) => prize.value === props.prizeAmount) + 1,
    prizeArray: prizeConfig.prizeArray,
    prizeOrderArray: prizeConfig.prizeOrderArray,
    showBonus: props.prizeMultiplier > 1,
    prizeMultiplier: props.prizeMultiplier,
    prizeAmount: props.prizeAmount,
    onFinishedCallback: props.onFinishedCallback,
    bonusText: renderBonusText(),
    currencySymbol: currency.symbol,
    prizeCurrencyCode: props.prizeCurrencyCode
  };

  return <BonusWheelView data={data} />;
};

export default BonusWheel;
